module.exports = __webpack_public_path__ + "media/images/banner-c2127bf23c05a5dc040d1cba5d8d2539.jpg";